import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CompanyLogoSoftware = ({ image }) => {
   
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const getBlobUrl = async (bufferData) => {
      if (!bufferData) return null;

      const base64String = String.fromCharCode.apply(null, bufferData.data);
      // console.log("base64Stringggg ", base64String);

      const imageUrl = base64String;
      //  console.log("imageUrlimageUrlimageUrl",imageUrl)
      try {
        const response = await axios.get(image, {
          headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
          },
          responseType: 'blob',
        });

        // console.log("response", response);

        // Create a URL for the blob
        const imageBlob = new Blob([response.data], { type: 'image/jpeg' });
        const blobUrl = URL.createObjectURL(imageBlob);

        setImageUrl(blobUrl);
        // console.log(blobUrl);
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    if (image) {
      getBlobUrl(image);
    }

    

    // Cleanup: Revoke the object URL to avoid memory leaks
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [image]);

  return (
    <div>
    {imageUrl ? (
      <img src={imageUrl} alt="Company Logo" className="image-size" />
    ) : (
      <p>Loading image...</p>
    )}
  </div>
  );
};

export default CompanyLogoSoftware;
